import { styled } from "@mui/material/styles";
import React, { FunctionComponent } from "react";
import Box, { BoxProps } from "../box/Box";

const PREFIX = "FlexRow";

const classes = {
	flexBlock: `${PREFIX}flexBlock`,
	flexInline: `${PREFIX}flexInline`,
	flexFullHeight: `${PREFIX}flexFullHeight`,
};

const StyledBox = styled(Box)(({
	theme,
}) => ({
	[`&.${classes.flexBlock}`]: {
		display: "flex",
	},

	[`&.${classes.flexInline}`]: {
		display: "inline-flex",
	},

	[`&.${classes.flexFullHeight}`]: {
		height: "100%",
	},
}));

export interface FlexRowProps extends Omit<BoxProps, "display" | "flexDirection"> {
	/** component should take up full height of container */
	fullHeight?: boolean;

	/** component is inline rather than full width */
	inline?: boolean;
}

export const FlexRow: FunctionComponent<FlexRowProps> = (props) => {
	const { className, fullHeight, inline, ...otherProps } = props;


	return (
		<StyledBox
			className={`${fullHeight ? classes.flexFullHeight : ""} ${inline ? classes.flexInline : classes.flexBlock} ${className || ""}`}
			{...otherProps}
		/>
	);
};

export default FlexRow;
